// extracted by mini-css-extract-plugin
export var compactFilters = "_dv-4";
export var detailImage = "_dv-1";
export var dropdownContainer = "_dv-2";
export var imageContainer = "_dv-0";
export var selectedCard = "_dv-3";